import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import black from "../../images/News/Black_friday.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import sanvalentino from "../../images/News/Promozioni San Valentino.jpg"


function SanValentinoNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"14.02.2024"}</p>
            <TitoloSezioni title={"Promo San Valentino"} />
            <figure className="text-center">
                <blockquote className="blockquote">
                    <br/>
                    <p style={{fontSize: "28px"}}>
                    <strong style={{fontSize: "36px"}}>30%</strong> su palestra intera e ridotta (3-6-12 mesi)
                        <br/>
                    <strong style={{fontSize: "36px"}}>30%</strong> su tessera PLUS (palestra + spa)
                        <br/>
                    <br/>
                        Per il nuoto libero e le multitessere (ULPS, TRIS, SUPER, OPEN)
                        <br/> sconto del <strong style={{fontSize: "36px"}}>50% </strong>sul secondo iscritto
                    </p>
                    <br/>
                </blockquote>
            </figure>
            <img className="col" src={sanvalentino} style={{maxWidth: "22em"}}/>
            <Space />

        </div>
    )
}
export default SanValentinoNews